import { required, email, helpers } from '@vuelidate/validators';
import { trans } from '@elements/translation';
import { PhoneNumber } from '@tools/phoneNumber';

export const getContactValidator = () => ({
  firstname: {
    required: helpers.withMessage(
      trans('contact_form.field.firstname.error.required'),
      required,
    ),
  },
  lastname: {
    required: helpers.withMessage(
      trans('contact_form.field.lastname.error.required'),
      required,
    ),
  },
  email: {
    required: helpers.withMessage(
      trans('contact_form.field.email.error.required'),
      required,
    ),
    email: helpers.withMessage(
      trans('contact_form.field.email.error.invalid_email'),
      email,
    ),
  },
  phoneNumber: {
    required: helpers.withMessage(
      trans('contact_form.field.phonenumber.error.invalid_phonenumber'),
      required,
    ),
    phone: helpers.withMessage(
      trans('contact_form.field.phonenumber.error.invalid_phonenumber'),
      (value) => value && new PhoneNumber(value).isValid,
    ),
  },
});
